<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Header({
              text:
                'Use this widget if you want to place another submenu on the page.'
            })
          ]
        }
      ]
    }
  }
}
</script>
